
      <div class="cuppa-dropdown" (clickOutside)="closeDropdown()">
          <div class="selected-list" #selectedList>
              <div class="c-btn form-control" (click)="toggleDropdown($event)" [ngClass]="{'disabled': settings.disabled}" [attr.tabindex]="0">
                  <span *ngIf="selectedItems?.length == 0">{{settings.text}}</span>
                  <span *ngIf="settings.singleSelection && !badgeTempl">
                      <span *ngFor="let item of selectedItems;trackBy: trackByFn.bind(this);">
                          {{item[settings.labelKey]}}
                      </span>
                  </span>
                  <span class="c-list" *ngIf="selectedItems?.length > 0 && settings.singleSelection && badgeTempl ">
                      <div class="c-token" *ngFor="let item of selectedItems;trackBy: trackByFn.bind(this);let k = index">
                      <span *ngIf="!badgeTempl" class="c-label">{{item[settings.labelKey]}}</span>
                  <span *ngIf="badgeTempl" class="c-label">
                                  <c-templateRenderer [data]="badgeTempl" [item]="item"></c-templateRenderer>
                              </span>
                  <span class="c-remove" (click)="onItemClick(item,k,$event)">
                                  <svg width="100%" height="100%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve">
          <g>
              <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                  c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                  C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                  s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"/>
          </g>
          </svg>

                              </span>



              </div>
              </span>
              <div class="c-list" *ngIf="selectedItems?.length > 0 && !settings.singleSelection">
                  <div class="c-token" *ngFor="let item of selectedItems;trackBy: trackByFn.bind(this);let k = index" [hidden]="k > settings.badgeShowLimit-1">
                      <span *ngIf="!badgeTempl" class="c-label">{{item[settings.labelKey]}}</span>
                      <span *ngIf="badgeTempl" class="c-label">
                                  <c-templateRenderer [data]="badgeTempl" [item]="item"></c-templateRenderer>
                              </span>
                      <span class="c-remove" (click)="onItemClick(item,k,$event)">
                                  <svg width="100%" height="100%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve">
          <g>
              <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                  c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                  C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                  s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"/>
          </g>
          </svg>

                              </span>
                  </div>
              </div>
              <span class="countplaceholder" *ngIf="selectedItems?.length > settings.badgeShowLimit">+{{selectedItems?.length - settings.badgeShowLimit }}</span>
              <!--            <span class="fa" [ngClass]="{'c-angle-down': !isActive,'fa-angle-up':isActive}"></span>
      --><span *ngIf="!isActive" class="c-angle-down">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 width="100%" height="100%" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve">
      <g>
      	<g id="_x31_0_34_">
      		<g>
      			<path d="M604.501,134.782c-9.999-10.05-26.222-10.05-36.221,0L306.014,422.558L43.721,134.782
      				c-9.999-10.05-26.223-10.05-36.222,0s-9.999,26.35,0,36.399l279.103,306.241c5.331,5.357,12.422,7.652,19.386,7.296
      				c6.988,0.356,14.055-1.939,19.386-7.296l279.128-306.268C614.5,161.106,614.5,144.832,604.501,134.782z"/>
      		</g>
      	</g>
      </g>
      </svg>

                  </span>
              <span *ngIf="isActive" class="c-angle-up">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 width="100%" height="100%" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve">
      <g>
      	<g id="_x39__30_">
      		<g>
      			<path d="M604.501,440.509L325.398,134.956c-5.331-5.357-12.423-7.627-19.386-7.27c-6.989-0.357-14.056,1.913-19.387,7.27
      				L7.499,440.509c-9.999,10.024-9.999,26.298,0,36.323s26.223,10.024,36.222,0l262.293-287.164L568.28,476.832
      				c9.999,10.024,26.222,10.024,36.221,0C614.5,466.809,614.5,450.534,604.501,440.509z"/>
      		</g>
      	</g>
      </g>

      </svg>

                  </span>
          </div>
      </div>
      <div [setPosition]="selectedListHeight?.val" class="dropdown-list" [ngClass]="{'dropdown-list-top': settings.position == 'top'}"
          [hidden]="!isActive">
          <div [ngClass]="{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}" class="arrow-2"></div>
          <div [ngClass]="{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}"></div>
          <div class="list-area">
              <div class="pure-checkbox select-all" *ngIf="settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection && data?.length > 0"
                  (click)="toggleSelectAll()">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelectAll" [disabled]="settings.limitSelection == selectedItems?.length"
                  />
                  <label>
                      <span [hidden]="isSelectAll">{{settings.selectAllText}}</span>
                      <span [hidden]="!isSelectAll">{{settings.unSelectAllText}}</span>
                  </label>
              </div>
              <div class="list-filter" *ngIf="settings.enableSearchFilter">
                  <span class="c-search">
                          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 width="100%" height="100%" viewBox="0 0 615.52 615.52" style="enable-background:new 0 0 615.52 615.52;"
      	 xml:space="preserve">
      <g>
      	<g>
      		<g id="Search__x28_and_thou_shall_find_x29_">
      			<g>
      				<path d="M602.531,549.736l-184.31-185.368c26.679-37.72,42.528-83.729,42.528-133.548C460.75,103.35,357.997,0,231.258,0
      					C104.518,0,1.765,103.35,1.765,230.82c0,127.47,102.753,230.82,229.493,230.82c49.53,0,95.271-15.944,132.78-42.777
      					l184.31,185.366c7.482,7.521,17.292,11.291,27.102,11.291c9.812,0,19.62-3.77,27.083-11.291
      					C617.496,589.188,617.496,564.777,602.531,549.736z M355.9,319.763l-15.042,21.273L319.7,356.174
      					c-26.083,18.658-56.667,28.526-88.442,28.526c-84.365,0-152.995-69.035-152.995-153.88c0-84.846,68.63-153.88,152.995-153.88
      					s152.996,69.034,152.996,153.88C384.271,262.769,374.462,293.526,355.9,319.763z"/>
      			</g>
      		</g>
      	</g>
      </g>

      </svg>
                      </span>
                  <span *ngIf="!settings.lazyLoading" [hidden]="filter == undefined || filter?.length == 0" class="c-clear" (click)="clearSearch()">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 viewBox="0 0 51.976 51.976" style="enable-background:new 0 0 51.976 51.976;" xml:space="preserve">
      <g>
      	<path d="M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0
      		C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778
      		c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828
      		c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828
      		l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z"/>
      </g>
      </svg>
                      </span>
                  <span *ngIf="settings.lazyLoading" [hidden]="filter == undefined || filter?.length == 0" class="c-clear" (click)="resetInfiniteSearch()">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 viewBox="0 0 51.976 51.976" style="enable-background:new 0 0 51.976 51.976;" xml:space="preserve">
      <g>
      	<path d="M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0
      		C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778
      		c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828
      		c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828
      		l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z"/>
      </g>
      </svg>
                      </span>

                  <input class="c-input" *ngIf="!settings.lazyLoading && !searchTempl" #searchInput type="text" [placeholder]="settings.searchPlaceholderText"
                      [(ngModel)]="filter">
                  <input class="c-input" *ngIf="settings.lazyLoading && !searchTempl" #searchInput type="text" [placeholder]="settings.searchPlaceholderText"
                      [(ngModel)]="filter" (keyup)="filterInfiniteList($event)">
                  <c-templateRenderer *ngIf="searchTempl" [data]="searchTempl" [item]="item"></c-templateRenderer>
              </div>
              <div class="filter-select-all" *ngIf="!settings.lazyLoading && settings.enableFilterSelectAll">
                  <div class="pure-checkbox select-all" *ngIf="filter?.length > 0 && filterLength > 0" (click)="toggleFilterSelectAll()">
                      <input type="checkbox" [checked]="isFilterSelectAll" [disabled]="settings.limitSelection == selectedItems?.length" />
                      <label>
                      <span [hidden]="isFilterSelectAll">{{settings.filterSelectAllText}}</span>
                      <span [hidden]="!isFilterSelectAll">{{settings.filterUnSelectAllText}}</span>
                  </label>
                  </div>
                  <label *ngIf="filterLength == 0" [hidden]="filter == undefined || filter?.length == 0">{{settings.noDataLabel}}</label>
              </div>
              <div class="filter-select-all" *ngIf="settings.lazyLoading && settings.enableFilterSelectAll">
                  <div class="pure-checkbox select-all" *ngIf="filter?.length > 0 && infiniteFilterLength > 0" (click)="toggleInfiniteFilterSelectAll()">
                      <input type="checkbox" [checked]="isInfiniteFilterSelectAll" [disabled]="settings.limitSelection == selectedItems?.length"
                      />
                      <label>
                      <span [hidden]="isInfiniteFilterSelectAll">{{settings.filterSelectAllText}}</span>
                      <span [hidden]="!isInfiniteFilterSelectAll">{{settings.filterUnSelectAllText}}</span>
                  </label>
                  </div>
              </div>
              <ul *ngIf="!settings.groupBy" [style.maxHeight]="settings.maxHeight+'px'" class="lazyContainer">
                  <span *ngIf="itemTempl">
                  <li *ngFor="let item of data | listFilter: filter : settings.searchBy; let i = index;" (click)="onItemClick(item,i,$event)" class="pure-checkbox">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelected(item)" [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                  <label></label>
                  <c-templateRenderer [data]="itemTempl" [item]="item"></c-templateRenderer>
              </li>
              </span>
                  <span *ngIf="!itemTempl && !settings.lazyLoading">
              <li *ngFor="let item of data | listFilter:filter : settings.searchBy; let i = index;" (click)="onItemClick(item,i,$event)" class="pure-checkbox">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelected(item)" [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                  <label>{{item[settings.labelKey]}}</label>
              </li>
              </span>
                  <span *ngIf="!itemTempl && settings.lazyLoading">
                  <div [ngStyle]="{'height':totalHeight+'px'}" style="position: relative;">

            
              <li *ngFor="let item of chunkArray ; let i = index;" (click)="onItemClick(item,i,$event)" style="position: absolute;width: 100%;" class="pure-checkbox" [styleProp]="chunkIndex[i]">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelected(item)" [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                  <label>{{item[settings.labelKey]}}</label>
              </li>
              </div>
              </span>
              </ul>
              <div *ngIf="settings.groupBy" [style.maxHeight]="settings.maxHeight+'px'" style="overflow: auto;">
                  <ul *ngFor="let obj of groupedData ; let i = index;" class="list-grp">
                      <h4 *ngIf="(obj.value | listFilter:filter : settings.searchBy )?.length > 0">{{obj.key}}</h4>
                      <span *ngIf="itemTempl">
              <li *ngFor="let item of obj.value | listFilter:filter : settings.searchBy; let i = index;" (click)="onItemClick(item,i,$event)" class="pure-checkbox">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelected(item)" [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                  <label></label>
                  <c-templateRenderer [data]="itemTempl" [item]="item"></c-templateRenderer>
              </li>
              </span>
                      <span *ngIf="!itemTempl">
              <li *ngFor="let item of obj.value | listFilter:filter : settings.searchBy; let i = index;" (click)="onItemClick(item,i,$event)" class="pure-checkbox">
                  <input *ngIf="settings.showCheckbox" type="checkbox" [checked]="isSelected(item)" [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"/>
                  <label>{{item[settings.labelKey]}}</label>
              </li>
              </span>
                  </ul>
              </div>
              <h5 class="list-message" *ngIf="data?.length == 0">{{settings.noDataLabel}}</h5>
          </div>
      </div>
      </div>
    


// WEBPACK FOOTER //
// ./node_modules/angular2-multiselect-dropdown/multiselect.component.d.ts.AngularMultiSelect.html